import React from "react";
import { MapContainer, TileLayer, LayersControl } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "proj4";
import "proj4leaflet";

// Define the EPSG:3413 projection (Arctic Polar Stereographic)
const arcticCrs = new L.Proj.CRS(
  "EPSG:3413",
  "+proj=stere +lat_0=90 +lon_0=-45 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
  {
    resolutions: [
      8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5,
    ],
    origin: [-4194304, 4194304],
    bounds: L.bounds([-4194304, -4194304], [4194304, 4194304]),
  }
);

const ArcticMap = () => {
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {/* MapContainer using EPSG:3413 projection */}
      <MapContainer
        center={[90, 0]} // Arctic Center (North Pole)
        zoom={8} // Adjust zoom level to fit the region
        crs={arcticCrs} // Use custom Arctic Polar Stereographic projection
        style={{ height: "100%", width: "100%" }}
      >
        <LayersControl position="topright" collapsed={false}>
          <LayersControl.BaseLayer name="Arctic Ocean Base" checked>
            {/* Use an Arctic-specific tile layer that supports EPSG:3413 */}
            <TileLayer
              url="https://services.arcgisonline.com/ArcGIS/rest/services/Polar/Arctic_Ocean_Base/MapServer/tile/{z}/{y}/{x}"
              attribution="&copy; Esri, USGS, NOAA"
            />
          </LayersControl.BaseLayer>
        </LayersControl>
      </MapContainer>
    </div>
  );
};

export default ArcticMap;
